import { cloneDeep } from 'lodash';

const state = {
  list: [],
  promo_code: {},
  edit_promo_code: {}
};

const getters = {
  list: (state) => {
    return state.list || {};
  },
  promo_code: (state) => {
    return state.promo_code || {};
  },
  edit_promo_code: (state) => {
    return state.edit_promo_code || {};
  }
};

const mutations = {
  SET_LIST(state, items) {
    state.list = items;
  },
  SET_PROMO_CODE(state, promo_code) {
    state.promo_code = cloneDeep(promo_code);
    state.edit_promo_code = cloneDeep(promo_code);
    const index = state.list.findIndex((x) => x.id === promo_code.id);
    if (index < 0) {
      state.list.push(cloneDeep(promo_code));
    } else {
      this._vm.$set(state.list, index, promo_code);
    }
  },
  EDIT_PROMO_CODE(state, item) {
    state.edit_promo_code = item;
  },
  REMOVE_PROMO_CODE(state, id) {
    state.list = state.list.filter((x) => x.id !== id);
  }
};

const actions = {
  load({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get('promocodes/getAll')
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  set({ commit }, item) {
    commit('SET_PROMO_CODE', item);
  },
  edit({ commit }, item) {
    commit('EDIT_PROMO_CODE', item);
  },
  save({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('promocodes/save', req)
        .then((response) => {
          commit('SET_PROMO_CODE', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  remove({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`promocodes/delete?id=${id}`)
        .then(() => {
          commit('REMOVE_PROMO_CODE', id);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
